
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { ROUTE_NAMES } from "@/routes";
import { IRootState } from "@/store/types";
import { TASK } from "@/store/task";
import { required } from "vuelidate/lib/validators";

export default Vue.extend({
  data() {
    return {
      accountNumber: "",
      isLoading: false
    };
  },
  computed: {
    task() {
      return store.state.application.jdeAccountSetupTask;
    },
    showModal: {
      get(): any {
        return !!this.task;
      },
      set(value: any) {
        if (!value) {
          store.commit(
            APPLICATION.NS(APPLICATION.MUTATIONS.SET_JDE_ACCOUNT_SETUP_TASK),
            null
          );
          this.resetForm();
        }
      }
    },
    applicationId(): any {
      return this.$route.params && this.$route.params.id;
    }
  },
  methods: {
    async onJdeAccountSetup() {
      const action = APPLICATION.NS(
        APPLICATION.ACTIONS.JDE_ACCOUNT_SET_UP_COMPLETE
      );
      if (this.task) {
        this.isLoading = true;
        const taskId = this.task.taskId;
        const success = await store.dispatch(action, {
          taskId,
          accountNumber: this.accountNumber
        });
        this.isLoading = false;
        if (success) {
          // hide modal and reset form values
          this.showModal = false;
          this.resetForm();
        }
      }
    },
    async resetForm() {
      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_APPLICATION),
        this.applicationId
      );

      await this.$store.dispatch(
        TASK.NS(TASK.ACTIONS.LOAD_APPLICATION_TIMELINE),
        this.applicationId
      );
    }
  },
  validations: {
    accountNumber: {
      required
    }
  }
});
